// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fieldsHolder_nnZ38 {
  display: flex;
  flex-direction: column;
}

.attributeSelector_MUUgZ {
  flex-grow: 1;
  max-height: 300px !important;
}

.label_NUYXL {
  width: 65px;
}

.field_wxwYO {
  padding: var(--size-padSmall);
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@leverege/molten/lib/filters/sort/AttributeSortModelEditor.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,6BAA6B;AAC/B","sourcesContent":[".fieldsHolder {\n  display: flex;\n  flex-direction: column;\n}\n\n.attributeSelector {\n  flex-grow: 1;\n  max-height: 300px !important;\n}\n\n.label {\n  width: 65px;\n}\n\n.field {\n  padding: var(--size-padSmall);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fieldsHolder": `fieldsHolder_nnZ38`,
	"attributeSelector": `attributeSelector_MUUgZ`,
	"label": `label_NUYXL`,
	"field": `field_wxwYO`
};
export default ___CSS_LOADER_EXPORT___;
